module.exports = __webpack_public_path__ + "static/media/default-profile-photo.b1eaf593.png";